<template>
  <div class="nps-container w-full">
    <div
      v-if="question_type === SurveyQuestion.NPS"
      class="mb-1 flex flex-row items-center justify-between gap-2"
    >
      <div>
        {{ $t('survey.labels.notAtAllLikely') }}
      </div>

      <div class="label-extremely-likely-top hidden">
        {{ $t('survey.labels.extremelyLikely') }}
      </div>
    </div>
    <div
      class="survey-rating mb-1 grid grid-cols-12 gap-1 gap-y-2"
      data-test="survey-rating"
    >
      <template
        v-for="(score, index) in scores"
        :key="score.value"
      >
        <div
          v-if="index === 6"
          class="col-spacer col-span-1"
        ></div>
        <div class="survey-buttons col-span-2 flex justify-center">
          <PButton
            data-test="button-survey-rating"
            style="height: 40px; width: 100%"
            :variant="score.active ? '' : 'outlined'"
            @click="!disabled && selectScore(score.value)"
            @mouseleave="!disabled && mouseLeave()"
            @mouseover="!disabled && mouseOver(score.value)"
          >
            <div>
              {{ score.value }}
            </div>
          </PButton>
        </div>
      </template>
    </div>
    <div
      v-if="question_type === SurveyQuestion.NPS"
      class="label-extremely-likely-bottom survey-rating-label block text-right"
    >
      {{ $t('survey.labels.extremelyLikely') }}
    </div>
  </div>
</template>

<script>
import { SurveyQuestion } from '@/app/data/model_constants';

const SCORES_DEFAULT = [
  { active: false, value: 0 },
  { active: false, value: 1 },
  { active: false, value: 2 },
  { active: false, value: 3 },
  { active: false, value: 4 },
  { active: false, value: 5 },
  { active: false, value: 6 },
  { active: false, value: 7 },
  { active: false, value: 8 },
  { active: false, value: 9 },
  { active: false, value: 10 },
];

export default {
  name: 'Rating',
  props: {
    disabled: { type: Boolean },
    default_value: { type: Number, default: null },
    question_type: { type: String, default: null },
  },

  data() {
    const scores = _.cloneDeep(SCORES_DEFAULT);

    if (typeof this.default_value === 'number') {
      scores.forEach((score, index) => {
        scores[index].active = score.value <= this.default_value;
      });
    }

    return {
      scores,
      selected: false,
      SurveyQuestion,
    };
  },

  watch: {
    default_value() {
      this.scores = _.cloneDeep(SCORES_DEFAULT);
      this.configureScore(this.default_value);
      this.selected = this.default_value >= 0 && this.default_value <= 10;
    },
  },

  methods: {
    mouseOver(scoreValue) {
      if (this.selected) return;
      this.configureScore(scoreValue);
    },

    mouseLeave() {
      if (this.selected) return;
      this.scores.forEach((score, index) => {
        this.scores[index].active = false;
      });
    },

    selectScore(scoreValue) {
      this.configureScore(scoreValue);
      this.selected = true;
      this.$emit('scoreSelected', scoreValue);
    },

    configureScore(scoreValue) {
      if (_.isNil(scoreValue)) return;

      this.scores.forEach((score, index) => {
        this.scores[index].active = score.value <= scoreValue;
      });
    },
  },
};
</script>

<style scoped>
.nps-container {
  container-type: inline-size;
  container-name: nps;
}

@container nps (min-width: 400px) {
  .survey-rating {
    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
  }
  .col-spacer {
    display: none !important;
  }
  .survey-buttons {
    grid-column: span 1 / span 1;
  }
  .label-extremely-likely-top {
    display: block !important;
  }
  .label-extremely-likely-bottom {
    display: none !important;
  }
}
</style>
